import JobItemType from '../../constants/JobItemType';

export function getJobItemIcon(type: JobItemType): string {
  switch (type) {
    case JobItemType.INTERVENTION:
      return 'person-wrench';
    case JobItemType.OPERATION:
      return 'wrench';
    case JobItemType.PART:
      return 'bolt';
    case JobItemType.SERVICE:
      return 'document';
    case JobItemType.COMMENT:
      return 'comment-chat-bubble';
  }
}